import {
  IChildrenProp,
  IColorProp,
  IOnlyIcon,
  ISize,
} from 'types/components/components.interface';
import './Label.scss';
import { Attributes, HTMLAttributes } from 'react';

interface ILabelProps
  extends IChildrenProp,
    IColorProp,
    ISize,
    Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
  withText?: boolean;
  isClear?: boolean;
  fullWidth?: boolean
}

const Label = ({
  children,
  color = 'black',
  size = 'default',
  isClear,
  withText,
  fullWidth,
  ...props
}: ILabelProps) => {
  return (
    <div
      {...props}
      className={`magellan-label${withText ? ' with-text' : ''} ${color} ${
        props.className
      } ${size} ${isClear ? 'isClear':''} ${fullWidth ? 'full-width':''}`}>
      {children}
    </div>
  );
};

export default Label;
